// sensei-app/client/ui/StudentCourseListView.js
import { ComponentBase } from "../../core/ComponentBase.js";
import { RpcDataProvider } from "../../core/RpcDataProvider.js";

export class StudentCourseListView extends ComponentBase {
    constructor(config) {
        super(config);
        this.dataProvider = null;
        this.dataView = null;
    }

    async initialize() {
        this.dataProvider = new RpcDataProvider({
            appClient: this.appClient,
            eventGroup: "studentCoursesProvider",
            rpcClass: "StudentCourseRpc",
            autoLoad: false,
            pageSize: 10,
        });
        await this.dataProvider.initialize();

        this.dataView = await this.createManagedComponent("DataView", null, {
            eventGroup: "studentCourses",
            dataProvider: this.dataProvider,
            title: "My Enrolled Courses",
            viewMode: 'card',
            autoLoad: false,
            fields: [
                { name: 'title', label: 'Course Title', render: (val) => `<h5>${val}</h5>` },
                {
                    name: 'description',
                    label: 'Description',
                    render: (value, item) => {
                        if (!value) {
                            return `<p class="text-muted">${this.t('No description available.')}</p>`;
                        }

                        const maxLength = 120; // Max characters to show initially
                        if (value.length <= maxLength) {
                            return `<p>${value}</p>`;
                        }

                        const truncatedText = value.substring(0, maxLength) + '...';
                        const readMoreId = `read-more-${item._id}`;
                        const readMoreLink = `<a href="#" id="${readMoreId}" class="text-primary fw-bold">${this.t('Read more')}</a>`;
                        setTimeout(() => {
                            const linkElement = document.getElementById(readMoreId);
                            if (linkElement) {
                                linkElement.onclick = (e) => {
                                    e.preventDefault();
                                    this.showFullDescription(item.title, value);
                                };
                            }
                        }, 0);

                        return `<p>${truncatedText} ${readMoreLink}</p>`;
                    }
                },

                {
                    name: 'progress',
                    label: 'Progress',
                    render: (progress, item) => {
                        if (!progress) {
                            return `<span class="badge bg-secondary">${this.t('Not Started')}</span>`;
                        }
                        const totalMarks = (item.topics || [])
                            .filter(t => t.isMandatory)
                            .reduce((sum, t) => sum + (t.marks || 0), 0);
                        const percentage = totalMarks > 0 ? Math.round((progress.totalScore / totalMarks) * 100) : 0;
                        let statusBadge = '';
                        if (progress.hasPassed) {
                            statusBadge = `<span class="badge bg-success">${this.t('Passed')}</span>`;
                        } else if (progress.isCompleted) {
                            statusBadge = `<span class="badge bg-warning text-dark">${this.t('Completed')}</span>`;
                        } else {
                            statusBadge = `<span class="badge bg-info">${this.t('In Progress')}</span>`;
                        }
                        return `
                        <div class="d-flex justify-content-between align-items-center mb-1">
                            ${statusBadge}
                            <small class="text-muted">${progress.totalScore} / ${totalMarks} Marks</small>
                        </div>
                        <div class="progress" role="progressbar" aria-label="Course progress" aria-valuenow="${percentage}" aria-valuemin="0" aria-valuemax="100" style="height: 8px;">
                            <div class="progress-bar" style="width: ${percentage}%"></div>
                        </div>
                    `;
                    }
                }
            ],
            actions: [
                {
                    label: 'View Schedule',
                    icon: 'bi-calendar-week',
                    className: 'btn-primary btn-sm',
                    eventName: 'viewSchedule'
                }
            ],
        });

        this.dataView.on('viewSchedule', (item) => {
            if (item && item._id) {
                this.appClient.layoutEngine.navigate(`/student/schedule?courseId=${item._id}`);
            } else {
                this.appClient.layoutEngine.navigate(`/student/schedule`);
            }
        });


        await super.initialize();
    }


    async initAfterLogin() {
        await this.dataProvider.loadData();
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'student-course-list-container h-100';
        }
        this.container.innerHTML = '';
        if (this.dataView) {
            this.container.appendChild(await this.dataView.render());
        }
        return this.container;
    }

    showFullDescription(title, description) {
        this.appClient.notifier.alert(description, {
            title: title,
            size: 'lg'
        });
    }


    destroy() {
        this.dataView?.destroy();
        this.dataProvider?.destroy(); // Also destroy the provider
        this.dataView = null;
        this.dataProvider = null;
        super.destroy();
    }
}